import {
  SellHeader,
  SellSearch,
  SellLandingHighlight
} from "components/UI/molecules";
import { SellTestimonials } from "components/UI/organisms";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import { INTERNAL_PATHS } from "routes/paths";

export const SellGiftCards = () => {
  return (
    <div className="sell-gift-cards">
      <ReactHelmetWithProvider>
        <meta
          name="description"
          content="Sell your gift cards online at GCX. A guaranteed safe, secure and reliable marketplace to sell gift cards for cash with no hidden fees."
        />
        <title>
          Sell Gift Cards: Exchange a Gift Card for Cash | gcx.raise.com
        </title>
        <link
          rel="canonical"
          href={process.env.REACT_APP_URL + INTERNAL_PATHS.SELL_GIFT_CARDS}
        />
      </ReactHelmetWithProvider>
      <SellHeader />
      <SellSearch />
      <SellLandingHighlight />
      <SellTestimonials />
    </div>
  );
};
